import EmotesApi from '@/api/emotes'

const api = EmotesApi

const namespaced = true

const state = {
  emotes: null
}

const getters = {
  list: state => {
    return state.emotes
  }
}

const actions = {
  fetch({ commit }) {
    api.get()
      .then(({ data }) => commit('setEmotes', data));
  }
}

const mutations = {
  setEmotes(state, payload) {
    state.emotes = payload
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
